// Local translations
export const T = {
  en_GB: {
    sections: "Sections",
    sectionsDescription: "Organize your PDF template into sections with different scopes",
    addSection: "Add Section",
    noSectionsDescription: "Create your first section to start building the PDF template.",
    deleteSection: "Delete Section",
    editSection: "Edit section",
    deleteSectionConfirmation: (name: string) =>
      `Are you sure you want to delete "${name}"? All pages and components in this section will be deleted.`,
    delete: "Delete",
    cancel: "Cancel",
    sectionDeletedSuccess: "Section deleted successfully",
    error: "Error",
    failedToDelete: "Failed to delete",
    failedToReorder: "Failed to reorder",
    global: "Global",
    perGoal: "Per Goal",
    perPortfolio: "Per Portfolio",
    name: "Name",
    sectionScope: "Section Scope",
    pages: "Pages",
    page: "page",
    components: "Components",
    component: "component",
    dragToReorder: "Drag and drop to reorder sections",
    addPortfolioContent: "Add portfolio content",
    portfolioSubNodeHint: "Portfolio content (rendered per portfolio of this goal)",
    aboutSectionScope: "About Section Scope:",
    globalSectionInfo:
      "Global sections are rendered once in the PDF, typically for cover pages, summaries, and terms",
    perGoalSectionInfo:
      "Per Goal sections are repeated for each investment goal; each carries a portfolio sub-node rendered once per portfolio",
  },
  nb_NO: {
    sections: "Seksjoner",
    sectionsDescription: "Organiser PDF-malen din i seksjoner med ulike omfang",
    addSection: "Legg til seksjon",
    noSectionsDescription: "Opprett din første seksjon for å begynne å bygge PDF-malen.",
    deleteSection: "Slett seksjon",
    editSection: "Rediger seksjon",
    deleteSectionConfirmation: (name: string) =>
      `Er du sikker på at du vil slette «${name}»? Alle sider og komponenter i denne seksjonen vil bli slettet.`,
    delete: "Slett",
    cancel: "Avbryt",
    sectionDeletedSuccess: "Seksjon slettet",
    error: "Feil",
    failedToDelete: "Kunne ikke slette",
    failedToReorder: "Kunne ikke endre rekkefølge",
    global: "Global",
    perGoal: "Per mål",
    perPortfolio: "Per portefølje",
    name: "Navn",
    sectionScope: "Seksjonsomfang",
    pages: "Sider",
    page: "side",
    components: "Komponenter",
    component: "komponent",
    dragToReorder: "Dra og slipp for å endre rekkefølge på seksjoner",
    addPortfolioContent: "Legg til porteføljeinnhold",
    portfolioSubNodeHint: "Porteføljeinnhold (vises per portefølje for dette målet)",
    aboutSectionScope: "Om seksjonsomfang:",
    globalSectionInfo:
      "Globale seksjoner vises én gang i PDF-en, typisk for forsider, sammendrag og vilkår",
    perGoalSectionInfo:
      "Per mål-seksjoner gjentas for hvert investeringsmål; hver har en porteføljeundernode som vises per portefølje",
  },
} as const;
